export enum LostReason {
  COMMERCIAL = "Commercial reasons",
  SERVICE = "Service",
  STAYED = "Stayed with incumbent",
  COVERAGE = "Coverage",
  DECISION = "Decision postponed",
  OTHER = "Other",
}
